import { Injectable, Inject, Injector } from '@angular/core';
import { forkJoin, Observable, ReplaySubject } from 'rxjs';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { BaseService } from 'src/modules/base/shared/services/base.service';
@Injectable()
export class TeleCommonService {
  private _loadedLibraries: { [url: string]: ReplaySubject<any> } = {};

  constructor(
    public injector: Injector,
    public baseService: BaseService,
    public alerts: AlertsService
  ) {
  }

  lazyLoadScript(script, document: Document): Observable<any> {
    return forkJoin([
      this.loadScript('assets/js/' + script, document),
    ]);
  }

  setUId(uid) {
    let resource = { uid: uid, is_mobile: /iPhone|iPad|iPod|Android|webOS|BlackBerry|Windows Phone/i.test(navigator.userAgent), user_agent: "" }
    this.baseService.add(resource, "uid_user_agent", true, "system-management").subscribe((res: any) => {
      if (res.errCode == 0) {

      } else {
        this.alerts.error(res.mesage);
      }
    })
  }

  getUId(id) {
    return new Promise((resolve) => {
      this.baseService.get("GET_PAGE", "", "uid_user_agent", "system-management", "uid:" + id).subscribe((res: any) => {
        if (res.errCode == 0) {
          (res.resource[0] && res.resource[0].is_mobile) ? resolve(res.resource[0].is_mobile): resolve(false);
        } else {
          this.alerts.error(res.mesage);
        }
      })
    })
  }


  public loadScript(url: string, document: Document): Observable<any> {
    if (this._loadedLibraries[url]) {
      return this._loadedLibraries[url].asObservable();
    }

    this._loadedLibraries[url] = new ReplaySubject();
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = url;
    script.onload = () => {
      this._loadedLibraries[url].next("");
      this._loadedLibraries[url].complete();
    };

    document.body.appendChild(script);

    return this._loadedLibraries[url].asObservable();
  }

}